var map = {
	"./Bhkw.png": 1041,
	"./Biogas.png": 6836,
	"./Charge.png": 281,
	"./Consumer.png": 4881,
	"./Schaltanlage.png": 6210,
	"./Solar.png": 9646,
	"./Wasser.png": 4722,
	"./Windkraft.png": 1649
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5994;